
export default {
  namespaced: true,
  state: {
    appVersion: process.env.VERSION ? ('v' + process.env.VERSION) : 'dev',
    appCopyrightInfo: 'Synergy Software Pty Ltd &copy; 2019-2025',
    consoleLog: [],
    appUserProxyAccess: false,
    appVersionUpdatedRequired: false
  },
  mutations: {
    addSystemLog (state, message) {
      state.consoleLog.push(message)
    },
    setUserProxyAccess (state, enabled) {
      state.appUserProxyAccess = enabled
    },
    setVersionUpdateRequired (state, enabled) {
      state.appVersionUpdatedRequired = enabled
    }
  }
}
